import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, AlertController } from '@ionic/angular/lazy';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-order-payment-options',
    templateUrl: './order-payment-options.component.html',
    styleUrls: ['./order-payment-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrderPaymentOptionsComponent implements OnInit {

    @Input() order_payment_page = null;

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        public alertController: AlertController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    presentOrderPaymentEditModal() {
        this.order_payment_page.presentOrderPaymentEditModal();
        this.dismiss();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

}
